import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Button,Checkbox,FormControl,FormControlLabel,FormGroup,IconButton,InputLabel,MenuItem,Select,Stack,TextField,} from '@mui/material';
import { format,useMask } from '@react-input/mask';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ProfilePic from "../../../assets/images/profile.png";
import { UserContext } from '../../../context/UserContext';
import { trackEventMatomo } from '../../../helpers/matomo';
import { userTag, userType } from '../../../types/users/types';
import { SimpleTeam } from '../../../types/teams/types';
import GenericAutoComplete from "../../GenericAutoComplete";

export default function EditUser({
  isLoading,
  role,
  isAdm,
  tags,
  teams,
  setOpenModalImg,
  user,
  setUser
}: {
  isLoading: boolean,
  role: string,
  isAdm: boolean
  tags: userTag[],
  teams: SimpleTeam[],
  setOpenModalImg: React.Dispatch<React.SetStateAction<boolean>>,
  user: userType | null,
  setUser: React.Dispatch<React.SetStateAction<userType | null>>
}) {
  const { t } = useTranslation('translation');
  const options = {
    mask: "(__) ____-_____",
    replacement: { _: /\d/ },
  };
  const inputRef = useMask(options);
  const telefoneFormatado = format(user?.contato ?? "", options);
  const { acessoPlanoDeAcao } = useContext(UserContext);

  function handleUser<K extends keyof userType>(campo: K, valor: userType[K]) {
    setUser(prev => prev ? { ...prev, [campo]: valor } : prev);
  }

  return (
    <Stack direction='column' justifyContent='flex-start' alignItems='flex-start' width='100%' spacing={2}>
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Stack
          direction="column"
          spacing={1}
          width='100%'
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Stack direction='row'>
            <TextField
              slotProps={{ htmlInput: { fontSize: '12px' } }}
              variant='standard'
              disabled
              value={user?.id}
              label={t('loginScreen.username')}
            />
            <IconButton
              onClick={() => { user && navigator.clipboard.writeText(user?.id); alert(t('editUserModal.idCopy')); }}
              disabled={isLoading}
              color='success'>
              <ContentCopyIcon />
            </IconButton>
          </Stack>
          <Stack direction='row'>
            <TextField
              slotProps={{ htmlInput: { fontSize: '12px' } }}
              variant='standard'
              disabled
              value={user?.email}
              label={t('users.email')}
            />
            <IconButton
              onClick={() => { user && navigator.clipboard.writeText(user?.email); alert(t('editUserModal.emailCopy')); }}
              disabled={isLoading}
              color='success'>
              <ContentCopyIcon />
            </IconButton>
          </Stack>
          {(role === 'Administrador' || role === 'Gestor' || isAdm)
            && <FormControlLabel
              control={
                <Checkbox
                  checked={user?.adm ?? false}
                  onChange={(e) => {
                    trackEventMatomo('modal edição de usuário', 'click', 'checkbox', 'seleciona valor');
                    setUser(prev => prev ? { ...prev, adm: e.target.checked } : prev);
                  }} />}
              label={t('editUserModal.userAdm')} />}
        </Stack>
        <Stack
          width='100%'
          justifyContent="flex-start"
          alignItems='flex-end'
        >
          <Stack
            direction="column"
            spacing={1}
            justifyContent="flex-start"
            alignItems='center'
          >
            <img
              src={(!user?.foto || user?.foto === "  ")
                ? ProfilePic
                : user.foto}
              alt="foto-perfil"
              style={{ width: '120px', borderRadius: '50%' }} />
            <Button
              variant='outlined'
              disabled={isLoading}
              startIcon={<AddPhotoAlternateIcon />}
              onClick={() => {
                trackEventMatomo('modal edição de usuário', 'click', ' button', 'abre modal');
                setOpenModalImg(true);
              }}
            >
              {t('editPic')}
            </Button>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        spacing={2}
      >
        <Stack
          width='100%'
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <TextField
            required
            fullWidth
            label={t('name')}
            onClick={() => trackEventMatomo('modal edição de usuário', 'click', ' input', 'edita valor')}
            value={user?.nome}
            onChange={(event) => handleUser('nome', event.target.value)}
          />
          <TextField
            fullWidth
            label={t('registration')}
            onClick={() => trackEventMatomo('modal edição de usuário', 'click', ' input', 'edita valor')}
            value={user?.matricula}
            onChange={(event) => handleUser('matricula', event.target.value)}
          />
          <FormControl fullWidth>
            <InputLabel>{t('status')}</InputLabel>
            <Select
              label={t('status')}
              value={user?.status ?? ''}
              onChange={(even) => handleUser('status', even.target.value)}
            >
              <MenuItem value="ativo">{t('active')}</MenuItem>
              <MenuItem value="inativo">{t('inactive')}</MenuItem>
            </Select>
          </FormControl>
        </Stack>
        <Stack
          width='100%'
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={2}
        >
          <FormControl fullWidth>
            <InputLabel>{t('profile')}</InputLabel>
            <Select
              label={t('profile')}
              disabled={user?.perfil === 'Administrador'}
              value={user?.perfil ?? ''}
              onChange={(even) => handleUser('perfil', even.target.value)}
            >
              <MenuItem value={"Gerente"}>{t("profiles.manager")}</MenuItem>
              <MenuItem disabled value={"Gestor"}>{t("profiles.coordinator")}</MenuItem>
              <MenuItem value={"Supervisor"}>{"Supervisor"}</MenuItem>
              <MenuItem value={"Usuario"}>{t("profiles.user")}</MenuItem>
            </Select>
          </FormControl>
          <TextField
            required
            fullWidth
            label={t('tel')}
            onClick={() => trackEventMatomo('modal edição de usuário', 'click', ' input', 'edita valor')}
            inputRef={inputRef}
            value={telefoneFormatado}
            onChange={(event) => handleUser('contato', event.target.value)}
          />
          <FormGroup onClick={() => trackEventMatomo('modal edição de usuário', 'click', ' checkbox', 'seleciona valor')}>
            <FormControlLabel
              control={<Checkbox
                checked={user?.aprovador ?? false}
                onChange={() => handleUser('aprovador', !user?.aprovador)} />}
              label={t('approver')} />
            {acessoPlanoDeAcao
              && <>
                <FormControlLabel
                  control={<Checkbox
                    checked={user?.gestorPA ?? false}
                    onChange={() => handleUser('gestorPA', !user?.gestorPA)} />}
                  label={t('users.userRegister.actionPlanManager')} />
                <FormControlLabel
                  control={<Checkbox
                    checked={user?.inspetorPA ?? false}
                    onChange={() => handleUser('inspetorPA', !user?.inspetorPA)} />}
                  label={t('users.userRegister.actionPlan')} />
              </>}
          </FormGroup>
        </Stack>
      </Stack>
      <Stack
        width='100%'
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <GenericAutoComplete
          label={t('selectTag')}
          options={tags
            ?.sort((a: userTag, b: userTag) => { return a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1; })
            ?.map((option: userTag) => (
              { value: option.id, label: option.name }
            )) || []}
          selectedValues={tags?.filter((tag: userTag) => user?.tags?.includes(tag.id)).map((e: userTag) => e.id) || []}
          onChange={(values) => setUser(prev => prev ? { ...prev, tags: values } : prev)}
        />
        <GenericAutoComplete
          label={t('Reports.multipleTeamSelect')}
          options={teams
            ?.sort((a: SimpleTeam, b: SimpleTeam) => { return a.nome?.toLowerCase() > b.nome?.toLowerCase() ? 1 : -1; })
            ?.map((option: SimpleTeam) => ({
              value: option.id, label: option.nome
            })) || []}
          selectedValues={teams?.filter((team: SimpleTeam) => user?.listaEquipes?.includes(team.id)).map((e: SimpleTeam) => e.id) || []}
          onChange={(values) => setUser(prev => prev ? { ...prev, listaEquipes: values } : prev)}
        />
      </Stack>
    </Stack>
  );
}
